export default function OpenLinkIcon(props: React.SVGAttributes<SVGSVGElement>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.9999 3.00001L6.74996 9.25001M12.9999 3.00001L13 6.75M12.9999 3.00001L9.24999 3M6.74999 3.00001H4C3.44772 3.00001 3 3.44772 3 4.00001V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V9.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
